import { render, staticRenderFns } from "./PritntingMap.vue?vue&type=template&id=68057c4c&scoped=true"
import script from "./PritntingMap.vue?vue&type=script&lang=js"
export * from "./PritntingMap.vue?vue&type=script&lang=js"
import style0 from "./PritntingMap.vue?vue&type=style&index=0&id=68057c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68057c4c",
  null
  
)

export default component.exports